import type {
	BoqStarterUnpriced,
	BoqStarterUnpricedGroup,
} from "@shared/types";
import type { TFunction } from "i18next";
import { formatCalendarDate } from "@/lib/format";
import type { BOQStarterWarning } from "../../services/boq/boq-api.service";

function params(
	unpriced: BoqStarterUnpriced,
	language: string,
): { hsn: string; date: string } {
	return {
		hsn: unpriced.hsnCode ?? "",
		date: unpriced.rateEffectiveFrom
			? formatCalendarDate(
					unpriced.rateEffectiveFrom,
					{ dateStyle: "medium" },
					// Indian conventions in either language: "1 Jun 2026".
					`${language.split("-")[0]}-IN`,
				)
			: "",
	};
}

/**
 * A preview warning in the reader's language: why an unpriced line has no
 * price and who can fix it, or the server's message for any other warning.
 */
export function warningText(
	t: TFunction,
	language: string,
	warning: BOQStarterWarning,
): string {
	if (!warning.unpriced || !warning.productName) return warning.message;
	return t(`boq.starter.unpriced.line.${warning.unpriced.reason}`, {
		product: warning.productName,
		...params(warning.unpriced, language),
		// A reason this build has no wording for.
		defaultValue: warning.message,
	});
}

/** One reason group of a `template_unpriced` failure, with its line count. */
export function unpricedGroupText(
	t: TFunction,
	language: string,
	group: BoqStarterUnpricedGroup,
): string {
	return t(`boq.starter.unpriced.group.${group.reason}`, {
		count: group.lines,
		...params(group, language),
		// A reason this build has no wording for.
		defaultValue: t("boq.starter.unpriced.group.unknown", {
			count: group.lines,
		}),
	});
}
